import React from "react";
// import { EditorState, ContentState, convertFromHTML, convertToRaw } from 'draft-js';
// import { Editor } from 'react-draft-wysiwyg';
// import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
// import draftToHtml from 'draftjs-to-html';
// import htmlToDraft from 'html-to-draftjs';

// import CKEditor from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Loader from 'react-loader-spinner';

// import {ClassicEditor} from '@ckeditor/ckeditor5-editor-classic';
import MyUploadAdapter from '../MyUploadAdapter'



function createMyUploadAdapterPlugin(onUploadStart, onUploadEnd) {
    return function MyUploadAdapterPlugin(editor) {
        editor.plugins.get('FileRepository').createUploadAdapter = function (loader) {
            const adapter = new MyUploadAdapter(loader);
            
            // Wrap the upload method to track upload state
            const originalUpload = adapter.upload.bind(adapter);
            adapter.upload = function() {
                if (onUploadStart) {
                    onUploadStart();
                }
                
                return originalUpload()
                    .then((result) => {
                        if (onUploadEnd) {
                            onUploadEnd();
                        }
                        return result;
                    })
                    .catch((error) => {
                        if (onUploadEnd) {
                            onUploadEnd();
                        }
                        throw error;
                    });
            };
            
            return adapter;
        };
    };
}


class Header extends React.Component {

    state = {
        categories: [],
        tags: [],
        reviewers: [],
        editorState: "",//EditorState.createWithContent(initialEditorContent)
        isUploading: false,
        uploadCount: 0
    }

    componentWillMount() {
        // console.log(this.props.data)
        if (this.props.data && this.props.data != '') {
            // const blocksFromHTML = convertFromHTML(this.props.data);
            // const initialEditorContent = ContentState.createFromBlockArray(
            //     blocksFromHTML.contentBlocks,
            //     blocksFromHTML.entityMap
            // );
            this.setState({ editorState: this.props.data })
        }
    }

    handleUploadStart = () => {
        this.setState(prevState => ({
            uploadCount: prevState.uploadCount + 1,
            isUploading: true
        }));
    }

    handleUploadEnd = () => {
        this.setState(prevState => {
            const newCount = Math.max(0, prevState.uploadCount - 1);
            return {
                uploadCount: newCount,
                isUploading: newCount > 0
            };
        });
    }

    handleChangeSelect = (name, newVal) => {
        this.setState({
            [name]: newVal
        });
    }

   

    onEditorStateChange = editorState => {
        this.setState({ editorState })
        this.props.changeValue(this.props.header.key, editorState)
        // console.log(draftToHtml(convertToRaw(editorState.getCurrentContent())))
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }

    render() {
        // console.log(CKEditor.config)
        const editorConfiguration = {
            extraPlugins: [createMyUploadAdapterPlugin(this.handleUploadStart, this.handleUploadEnd)],
            mediaEmbed: {
                previewsInData: true
            },
        };

        return (
            <div className='mt-0 w-100' style={{ position: 'relative' }}>
                {/* <label className={'mb-2 mr-1 ml-1 ' + (this.conditionalSettings('required', true) ? 'required' : '')} style={{ marginBottom: 3, fontSize: 12, marginTop: 5, color: '#999' }}>{this.props.label}</label> */}
                <div className="w-100" style={{ direction: 'ltr', position: 'relative' }}>

                    <CKEditor
                        config={editorConfiguration}
                        editor={ClassicEditor}
                        data={this.state.editorState}
                        onReady={editor => {
                            // You can store the "editor" and use when it is needed.
                            console.log('Editor is ready to use!', editor);
                        }}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            this.onEditorStateChange(data)
                        }}
                        onBlur={(event, editor) => {
                            // console.log('Blur.', editor);
                        }}
                        onFocus={(event, editor) => {
                            // console.log('Focus.', editor);
                        }}
                    />

                    {this.state.isUploading && (
                        <div style={{ 
                            justifyContent: 'center', 
                            alignItems: 'center', 
                            display: 'flex', 
                            backgroundColor: '#00000050', 
                            position: 'absolute', 
                            top: 0, 
                            left: 0, 
                            width: '100%', 
                            height: '100%',
                            zIndex: 1000,
                            borderRadius: '4px'
                        }}>
                            <Loader
                                type="Oval"
                                color="#fff"
                                height={80}
                                width={80}
                            />
                        </div>
                    )}
                   
                </div>
                {/* <input onChange={e=>{this.props.onChange(this.props.header.key,e.target.value)}} className='mediumiransansfont form-control' defaultValue={this.props.data} style={{backgroundColor:'#f7f7f7', color: '#3b3a40' }}/> */}
            </div>
        );
    }
}

export default Header;
